import { PaletteColorOptions } from '@mui/material/styles';

export const renoworksPrimaryPalette: PaletteColorOptions = {
  50: '#f5f5f5',
  100: '#cadae2',
  200: '#acc0cb',
  300: '#8ca6b5',
  400: '#7492a3',
  500: '#5c7f92',
  600: '#507081',
  700: '#415c6a',
  800: '#334955',
  900: '#22343e',
  main: '#334955',
  dark: '#22343e',
  light: '#7492a3',
};

export const renoworksSecondaryPalette: PaletteColorOptions = {
  50: '#fffee7',
  100: '#fefac3',
  200: '#fdf69b',
  300: '#fbf272',
  400: '#f8ed50',
  500: '#f6e82b',
  600: '#fcdc2d',
  700: '#fbc424',
  800: '#faab19',
  900: '#f88203',
  main: '#faab19',
  dark: '#f88203',
  light: '#f8ed50',
};

export const themeConstants = {
  WHITE: '#fff',
  BLACK: '#222f34',
  fontSize: 14,
  htmlFontSize: 16,
};